import account from "./account.json";
import common from "./common.json";
import consent from "./consent.json";
import errors from "./errors.json";
import footer from "./footer.json";
import home from "./home.json";
import language from "./language.json";
import legal from "./legal.json";
import library from "./library.json";
import movieDetail from "./movieDetail.json";
import movies from "./movies.json";
import nav from "./nav.json";
import userPages from "./userPages.json";

/**
 * One JSON file per namespace keeps feature work isolated.
 * Keys are accessed as `namespace.key` via `createTranslator`.
 */
const translations = {
  account,
  common,
  consent,
  errors,
  footer,
  home,
  language,
  legal,
  library,
  movieDetail,
  movies,
  nav,
  userPages,
};

export default translations;
